module.exports = __webpack_public_path__ + "img/noeyez.198da4bf.svg";